import { render, staticRenderFns } from "./Faqs_add.vue?vue&type=template&id=3d466a6e&scoped=true&"
import script from "./Faqs_add.vue?vue&type=script&lang=js&"
export * from "./Faqs_add.vue?vue&type=script&lang=js&"
import style0 from "./Faqs_add.vue?vue&type=style&index=0&id=3d466a6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d466a6e",
  null
  
)

export default component.exports